﻿'use strict';

/**
 * @ngdoc function
 * @name ntmApp.controller:findStaffController
 * @description
 * # findStaffController
 * Controller of the ntmApp
 */
angular.module('ntmApp')
  .controller('findStaffController', ['$uibModalInstance', '$scope', 'data', 'ForecastService', 'ForecastConfirmationService', 'FlashService', 'ForecastingFiltersProvider', 'FindStaffFilter', 'Utils',
      function ($uibModalInstance, $scope, data, ForecastService, ForecastConfirmationService, FlashService, ForecastingFiltersProvider, FindStaffFilter, Utils) {

          var staffGridData = [];

          function initData() {

              $scope.loading = true;
              $scope.showFilters = true;
              $scope.filterDataSource = {};
              $scope.StaffFilters = new FindStaffFilter();

              ForecastingFiltersProvider.LoadFilters().then(function (filters) {
                  $scope.filterDataSource.facilityFilters = data.requestData.forecastView === 1 ? filters.facilityFilters.filter(function (facility) { return facility.id !== data.requestData.forecastScope; }) : filters.facilityFilters;
                  $scope.filterDataSource.skillsFilters = filters.skillsFilters;

                  $scope.filterDataSource.skillsFilters.forEach(function (skill) {
                      skill.id = skill.skillSetId;
                      skill.value = skill.skillSetName;
                  });

                  ForecastService.GetStaffGrid(data.requestData).then(function (result) {
                      staffGridData = result.data.staffs;
                      $scope.loading = false;
                  });
              });
          }

          $scope.performFiltering = function () {

              $scope.filteredData = $scope.StaffFilters.performFiltering(staffGridData);

              $scope.showFilters = false;
              $scope.showGrid = true;
          };

          $scope.returnToFilters = function () {              
              $scope.showFilters = true;
              $scope.showGrid = false;
          };

          $scope.borrow = function () {

              var requestData = prepareData();
              if (data.requestData.forecastView === 0) {

                  var popup = Utils.OpenModal('', 'ng1/src/staffForecasting/borrowerResources/dialogs/selectBorrowFacilitiesDialog.html', 'selectBorrowFacilitiesController', { options: data.scope.list });

                  popup.result.then(function (result) {
                      requestData.facilityCodes = result.map(function (item) { return item.id; });
                      permissionCheck(requestData);
                  });
              } else {

                  requestData.facilityCodes.push(data.requestData.forecastScope);
                  permissionCheck(requestData);
              }             
              
          };

          $scope.getFilteredStaff = function () {
              
              $scope.filteredData.forEach(function (staff) {
                  staff.visibleDays = $scope.StaffFilters.allDays ? staff.days : staff.days.filter(function (day) {
                      return $scope.isVisible(day);
                  });

                  staff.showStaff = staff.visibleDays.length > 0;
              });

              return $scope.filteredData;
          };

          $scope.isVisible = function (day, skipAttendance) {

              if (!skipAttendance && day.attendance !== 'on') {
                  return false;
              }

              if (data.requestData.forecastView === 1) {
                  return !day.isAlreadyBorrowed;
              }

              if (data.requestData.forecastView === 0) {
                  if (!day.staffBrwFacilities || day.staffBrwFacilities.length === 0) {
                      return true;
                  }

                  return !(data.scope.list || []).every(function (facility) {
                      return (day.staffBrwFacilities).some(function (borrowedFacility) { return borrowedFacility.id === facility.id; });
                  });
              }
          };

          $scope.checkItem = function (event) {

              event.stopPropagation();

              $scope.isChecked = false;
              $scope.filteredData.forEach(function (staff) {
                  staff.days.forEach(function (day) {
                      if (day.checked) {
                          $scope.isChecked = true;
                      }
                  });
              });
          };

          $scope.dismiss = function () {
              $uibModalInstance.dismiss();
          };

          function permissionCheck(requestData) {

              var staffWithotPermissions = requestData.borrowStaffs.filter(function (staff) { return data.permissionToSchedules.indexOf(staff.personId) === -1; });

              if (staffWithotPermissions.length > 0) {
                  var msg = "Warning: you do not have permission to schedule the following selected staff, are you sure you want to continue?<br>";

                  staffWithotPermissions.forEach(function (staff) {
                      msg += '<br>{0}'.format(staff.name);
                      if (staff.staffSetupFacilities.length > 0) {
                          msg += ' [{0}'.format(staff.staffSetupFacilities.map(function (item) { return item.value; }).join(',')) + ']';
                      }
                  });

                  var calback = function () { confirmBorrow(requestData); };

                  ForecastConfirmationService.PermissionWarning(msg)
                                                .Yes(calback)
                                                .Ask();
              } else {
                  confirmBorrow(requestData);
              }

          }

          function confirmBorrow(data) {
              var msg = "The following staff will be borrowed, do you confirm?<br><br>";

              data.borrowStaffs.forEach(function (staff) {
                  staff.days.forEach(function (day) {
                      msg += '{0} on {1}<br>'.format(staff.name, moment(day).format("dddd, MMMM DD YYYY"));
                  });
              });

              var borrowActionCallback = function () { sendBorrowAction(data); };

              ForecastConfirmationService.BorrowAction(msg)
                                            .Yes(borrowActionCallback)
                                            .Ask();
             
          }

          function sendBorrowAction(requestData) {
              var loadingModal = FlashService.Loading();
              ForecastService.BorrowStaff(requestData).then(function (result) {

                  if (result.success) {
                      data.reloadBorrowerPane(data.header, data.selectedWeek, data.scenarioId, data.staffHeadersLoad, data.underAllocatedStaffLoad, true);

                      $scope.filteredData.forEach(function (staff) {
                          staff.days.forEach(function (day) {
                              if (day.checked) {
                                  day.checked = false;
                                  day.isAlreadyBorrowed = true;
                              }
                          });
                      });

                      FlashService.Success("Staff successfully borrowed.");
                  }

                  loadingModal.dismiss();
              });
          }

          function prepareData() {
              var result = {
                  scenarioBreadcrumb: data.requestData.scenarioBreadcrumb,
                  facilityCodes: [],
                  borrowStaffs: []
              };

              $scope.filteredData.forEach(function (staff) {
                  var borrowStaff = { personId: staff.personId, name: staff.staffName, staffSetupFacilities: staff.staffSetupFacilities, days: [] };

                  staff.days.forEach(function (day) {
                      if (day.checked) {
                          borrowStaff.days.push(day.date);
                      }
                  });

                  if (borrowStaff.days.length > 0) {
                      result.borrowStaffs.push(borrowStaff);
                  }
              });

              return result;
          }

          initData();

      }]);